// Named `*Param` rather than after the type itself: `import * as Number`
// shadows the global in the transpiled module, and the CommonJS interop the
// build emits calls Object.defineProperty at the top of the file — against the
// shadowed binding, before it is initialised. The failure is "Cannot read
// properties of undefined" pointing at the import line, which reads as a
// broken module rather than a naming collision.
import * as TextParam from "./text";
import * as CheckboxParam from "./checkbox";
import * as OptionsParam from "./options";
import * as NumberParam from "./number";
import * as ColorParam from "./color";
import * as IconParam from "./icon";
import * as ListParam from "./list";
import * as ObjectParam from "./object";
import * as DateParam from "./date";
import * as TimeParam from "./time";

const branches = [
  ...TextParam.schema,
  ...CheckboxParam.schema,
  ...OptionsParam.schema,
  ...NumberParam.schema,
  ...ColorParam.schema,
  ...IconParam.schema,
  ...ListParam.schema,
  ...ObjectParam.schema,
  ...DateParam.schema,
  ...TimeParam.schema,
];

// Every branch of the param union names the widget that renders it, and it is
// named HERE rather than on each document because it is one decision: in a
// listing the config column shows the branch as one line of details — see
// @repoflow/components/widgets/param-details, which is also why the label on
// `config` in ../utils is "Details" — and in a form it is the branch's fields,
// through that widget's Edit. form-schema picks a resolved oneOf branch's
// widget from the branch document alone, so a listing config could not ask for
// this itself. `/Types/Image` is a value shape, not a branch, and keeps its own.
export const schema = branches.map((doc) =>
  doc.id.startsWith("/Types/Param/Type/")
    ? { ...doc, widget: "paramDetails" }
    : doc,
);
